import React from 'react';

const CareersHeader = () => {
  return (
    <div className="row">
      <div className="col-md-8">
        <div className="subtitle without bigger">
          Join our team
          <div className="extra">
            All products that we develop change the world. Many of our products
            involve the usage of cutting edge technologies.
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareersHeader;
